/************************************************************
 Blood Namespace
 ************************************************************/

window.operatingRoomNS = {
    _action:null,
    _callback:null,
    _row:null,

    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;
        this._action.to_state_id = this._action.to_state_id.replace("{","").replace("}","").split(",")[0];
        this._action.to_state_id_arr = this._action.to_state_id.replace("{","").replace("}","").split(",")
        debug.log('operatingRoomNS', action.wf_id, action.wf_action_id, this._action.to_state_id, this._action.to_state_id_arr );

        // Cancel Requisition
        if (actionId == 3 || actionId == 17 || actionId == 60 || actionId == 65 || actionId == 81 || actionId == 83) {
            operatingRoomNS.openReason(operatingRoomNS.updateStateSurgicalOperationOperation);
        } else if(actionId == 47 || actionId == 66 || actionId == 67 || actionId == 68 || actionId == 86 || actionId == 89 || actionId == 90 || actionId == 91 || actionId == 92) {
            operatingRoomNS.openReason(operatingRoomNS.updateStateSurgicalOperationOperation);
        } else if (actionId == 62 || actionId == 72 || actionId == 12 ||actionId == 80 || actionId == 82 || actionId == 84) {
            operatingRoomNS.openDateHourPicker(operatingRoomNS.updateStateSurgicalOperationOperation);
        } else if (actionId == 63) {
            operatingRoomNS.openSurgicalOperationModal(operatingRoomNS.setSurgicalOperationState);
        } else if (actionId == 6  || actionId == 2) {
            operatingRoomNS.openScheduleWindow(operatingRoomNS.scheduleOperation);
        } else if (actionId == 73 || actionId == 64) {
            operatingRoomNS.openOtherLocationWindow(operatingRoomNS.setSurgicalRecoveryOtherLocation);
        } else if (actionId == 190){ // Surgery not performed
            debug.log("Surgery not performed", this._action.task_id);
            operatingRoomNS.openReason(operatingRoomNS.updateStateSurgicalOperationOperation);
        }
        // Print Surgical Report
        else if(actionId == 97){


            var p = {
                treatment_id: action.task_id,
                surgical_operation_id: null
            };

            debug.log("check treatment_id: ", action.task_id);

            // Validate if external report exists
            $.getJSON('/clinical_history/get_external_surgical_reports', p)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    //debug.log('check external report', data);

                    if (typeof data !== 'undefined' && data.length > 0){ //data[0].external_surgical_report != null
                        //debug.log('check external report', data[0].external_surgical_report);

                        if (data[0].external_surgical_report != 'false' && data[0].external_surgical_report != null){
                            var link = $('<iframe src="' + data[0].external_surgical_report + '" style="width:800px; height:600px" frameborder="0" marginwidth="0" marginheight="0" />');
                            $(link).fancybox({width: 800, height: 600, autoSize: false}).click();

                            operatingRoomNS._callback(true, operatingRoomNS._action, operatingRoomNS._row);
                        } else{
                            var url = "/surgery/patient_surgical_report?treatment_id="+action.task_id+"&patient_id="+row.patient_id;

                            Hades.showDocument(url);
                            operatingRoomNS._callback(true, operatingRoomNS._action, operatingRoomNS._row);
                        }

                    }else{
                        var url = "/surgery/patient_surgical_report?treatment_id="+action.task_id+"&patient_id="+row.patient_id;

                        Hades.showDocument(url);
                        operatingRoomNS._callback(true, operatingRoomNS._action, operatingRoomNS._row);
                    }


                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                });


        }
        else {
            operatingRoomNS.executeGenericAction();
        }
    },
    openReason:function (callback) {
        Hades.showLoading();

        var params = {
            task_id:operatingRoomNS._action.task_id,
            wf_id:operatingRoomNS._action.wf_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id};

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    openDateHourPicker: function (callback){
        Hades.showLoading();

        var params = {
            task_id:operatingRoomNS._action.task_id,
            wf_id:operatingRoomNS._action.wf_id,
            wf_from_status_id:operatingRoomNS._action.from_state_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id
        };

        $.get('/modal/date_hour_picker', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#date-hour-picker-modal-ct').bind('dateHourConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    openSurgicalOperationModal: function (callback) {
        Hades.showLoading();

        var params = {
            task_id:operatingRoomNS._action.task_id,
            wf_id:operatingRoomNS._action.wf_id,
            wf_from_status_id:operatingRoomNS._action.from_state_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id
        };

        $.get('/operating_room/management/surgical_operation_modal', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#surgical-operation-modal-ct').bind('surgicalOperationConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    updateStateSurgicalOperationOperation: function (event, data) {
        $.fancybox.close(true);

        debug.log("updat surgery status", operatingRoomNS._action.to_state_id[0]);

        Hades.showLoading();

        var params = {
            task_id:operatingRoomNS._row.task_id,
            reason_id:data.reasonId,
            other_reason:data.otherReason,
            date:data.date,
            hour:data.hour,
            wf_id:operatingRoomNS._action.wf_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id
        };

        $.post('/operating_room/management/update_state_surgical_operation', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    //Hades.showError(Hades.genericErrorMsg(), data.error);
                    bootbox.alert(data.error);
                    Hades.hideLoading();
                    return false
                    operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
                } else {
                    operatingRoomNS._callback(true, operatingRoomNS._action, operatingRoomNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                //Hades.showError(error, xhr.responseText, xhr, status, error);
                bootbox.alert(data.error);
                Hades.hideLoading();
                return false
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    setSurgicalOperationState: function (event, data) {
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {
            task_id:operatingRoomNS._row.task_id,
            date:data.date,
            hour:data.hour,
            physical_space_id: data.physical_space_id,
            wf_id:operatingRoomNS._action.wf_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id
        };

        $.post('/operating_room/management/set_surgical_operation_state', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
                } else {
                    operatingRoomNS._callback(true, operatingRoomNS._action, operatingRoomNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    openScheduleWindow: function () {
        var params = {
            task_id:operatingRoomNS._action.task_id,
            wf_id:operatingRoomNS._action.wf_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id
        };

        Hades.loadScreen('/operating_room/management/schedule_surgical_operation', params, null, true);
    },

    scheduleOperation: function (event, data) {
        Hades.showLoading();

        var params = {
            task_id: operatingRoomNS._action.task_id,
            wf_id: operatingRoomNS._action.wf_id,
            wf_status_id: operatingRoomNS._action.to_state_id,
            wf_action_id: operatingRoomNS._action.wf_action_id,
            operation_date: data.operation_date,
            operation_hour: data.operation_hour,
            operation_room_id: data.operation_room_id,
            inpatient_date: data.inpatient_date,
            inpatient_hour: data.inpatient_hour,
            physical_space: data.physical_space,
            slot: data.slot
        };

        $.post('/operating_room/management/schedule_surgical_operation', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
                } else {
                    operatingRoomNS._callback(true, operatingRoomNS._action, operatingRoomNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    openOtherLocationWindow: function (callback) {
        Hades.showLoading();

        var params = {
            task_id:operatingRoomNS._action.task_id,
            wf_id:operatingRoomNS._action.wf_id,
            wf_from_status_id:operatingRoomNS._action.from_state_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id
        };

        $.get('/operating_room/management/open_recovery_other_location', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content:data, autoScale:true, autoDimensions:true});

                $('#recovery-other-location-modal-ct').bind('recoveryOtherLocationConfirm', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    setSurgicalRecoveryOtherLocation: function (event, data) {
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {
            task_id:operatingRoomNS._row.task_id,
            physical_space_id:data.physical_space_id,
            slot_id:data.slot_id,
            date:data.date,
            hour:data.hour,
            wf_id:operatingRoomNS._action.wf_id,
            wf_status_id:operatingRoomNS._action.to_state_id,
            wf_action_id:operatingRoomNS._action.wf_action_id
        };

        $.post('/operating_room/management/set_surgical_recovery_other_location', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    bootbox.alert(data.error);
                    //Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    return false;
                    operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
                } else {
                    operatingRoomNS._callback(true, operatingRoomNS._action, operatingRoomNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                bootbox.alert(data.error);
                //Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                return false;
                operatingRoomNS._callback(false, operatingRoomNS._action, operatingRoomNS._row);
            });
    },

    executeGenericAction:function () {
        // Show alert for actions without undo
        workflow.executeAction(operatingRoomNS._action, operatingRoomNS._callback, operatingRoomNS._row);
    },

    isValidOperatingRoomDates: function (previousDate, previousHour, date, hour, lang_id) {

        var previousPieces = previousDate.split('-');
        previousPieces.reverse();
        var previousReversed = previousPieces.join('-');

        var pieces = date.split('-');
        pieces.reverse();
        var reversed = pieces.join('-');

        if (lang_id != 2) {
        var _previousDate = new Date(previousReversed + ' ' + previousHour);
        var _date = new Date(reversed + ' ' + hour);
        }
        else
        {
            var _previousDate = new Date(previousDate + ' ' + previousHour);
            var _date = new Date(date + ' ' + hour);
        }


        if (_previousDate > _date)
        {
            return false;
        }
        else {
            return true;
        }


    }
};